module.exports = __webpack_public_path__ + "static/media/clock-counterclockwise.d6cbe811.svg";